import { notice } from 'JS/utils/notice';
import ApplyGetCource from 'JS/classes/ApplyGetCource';
import { lockScroll, unlockScroll } from 'JS/utils/lock-screen';

class Signup {
    signupContainer;
    signupOffers;
    signupBtn;
    signupPrice = 0;
    offersTotal;

    modalFormSubmit;
    modalForm;
    modalFormClose;
    modalFormContainer;
    modalFormSelectedOffers;
    modalOpened = false;

    offerInfo;
    popupDesc;
    popupDescContent;
    popupOverlay;
    popupDeltaY = 36;
    popupDeltaX = 17;
    popupDeltaXRightFloat = 24;
    popupShowed = false;
    popupDescClose;

    ApplyGetCource;

    constructor(elm) {
        this.signupContainer = elm;
        this.signupOffers = this.signupContainer.querySelectorAll('input[name="block-signup__checkbox"]');
        this.signupBtn = this.signupContainer.querySelector('.info-tip__button');
        this.offersTotal = this.signupContainer.querySelector('.info-tip__options');

        this.modalFormContainer = document.querySelector('.modal--singup-form');
        this.modalForm = this.modalFormContainer.querySelector('.signup-form');
        this.modalFormClose = this.modalFormContainer.querySelector('.signup-form__close');
        this.modalFormSubmit = this.modalFormContainer.querySelector('.signup-form__submit');
        this.modalFormSelectedOffers = this.modalFormContainer.querySelector('[name="selected_offers"]');

        this.offerInfo = this.signupContainer.querySelectorAll('.block-signup__offer-info-desc');
        this.popupDesc = this.signupContainer.querySelector('.block-signup__offer-desc');
        this.popupDescContent = this.popupDesc.querySelector('.block-signup__offer-desc__content');
        this.popupDescClose = this.popupDesc.querySelector('.block-signup__offer-desc__close');
        this.popupOverlay = this.signupContainer.querySelector('.block-signup__offer-desc__overlay'); 
        
        this.ApplyGetCource = new ApplyGetCource(this.modalForm);

        this.initListeners();
    }

    initListeners() {
        this.signupOffers.forEach((elm) => elm.addEventListener('click', this._selectOffer));
        this.signupBtn.addEventListener('click', this._clickSignup);
        this.offerInfo.forEach((elm) => elm.addEventListener('click', this._clickOfferInfo));
        this.popupDescClose.addEventListener('click', () => {
            this.hidePopupInfo();
        });
        this.popupOverlay.addEventListener('click', () => {
            this.hidePopupInfo();
        });

        this.modalFormClose.addEventListener('click', () => {
            this.closeModal();
        });

        window.addEventListener('click', (e) => {  
            if (!e.target.closest('.block-signup__offer-desc') && this.popupShowed) {
                this.hidePopupInfo();
            }
        });
    }

    _clickOfferInfo = (e) => {
        e.stopPropagation();
        const elm = e.target.closest('.block-signup__offer-info-desc');

        const screenWidth = window.screen.width;
        if (screenWidth < 768) {
            if (!this.popupShowed) {
                lockScroll();
                this.popupDescContent.innerHTML = elm.getAttribute('data-desc');
                this.popupOverlay.classList.add('show');
                this.showPopupInfo();
            }
        } else {
            if (this.popupShowed) {
                this.hidePopupInfo();
                setTimeout(() => {
                    this.popupDescContent.innerHTML = elm.getAttribute('data-desc');
                    this.changePopupInfoPos(elm);
                }, 150);
            } else {
                this.popupDescContent.innerHTML = elm.getAttribute('data-desc');
                this.changePopupInfoPos(elm);
                this.showPopupInfo();
            }
        }
    }

    showPopupInfo() {
        this.popupShowed = true;
        this.popupDesc.classList.add('block-signup__offer-desc--show');
    }

    hidePopupInfo() {
        this.popupShowed = false;
        this.popupDesc.classList.remove('block-signup__offer-desc--show');
        const screenWidth = window.screen.width;
        if (screenWidth < 768) {
            this.popupOverlay.classList.remove('show');
            unlockScroll();
        }
    }

    changePopupInfoPos(elm) {
        const popupDescRect = this.popupDesc.getBoundingClientRect();
        const signupContainerRect = this.signupContainer.getBoundingClientRect();
        const elmRect = elm.getBoundingClientRect();

        let popupDescTop = elmRect.top - signupContainerRect.top + this.popupDeltaY;
        let popupDescLeft = elmRect.left - signupContainerRect.left - this.popupDeltaX;

        if (popupDescRect.width + popupDescLeft > signupContainerRect.width) {
            popupDescLeft = popupDescLeft - popupDescRect.width + 2 * this.popupDeltaX + this.popupDeltaXRightFloat;
            this.popupDesc.classList.add('right-float');
        } else {
            this.popupDesc.classList.remove('right-float');
        }

        this.popupDesc.style.top = popupDescTop + 'px';
        this.popupDesc.style.left = popupDescLeft + 'px';
    }

    _selectOffer = (e) => {
        const selectedOffers = this.signupContainer.querySelectorAll('input[name="block-signup__checkbox"]:checked');
        this.signupPrice = 0;
        const offers = [];
        selectedOffers.forEach((elm) => {
            this.signupPrice += Number(elm.getAttribute('data-price'));
            offers.push(elm.value);
        });

        const selectedOptionsHtml = `
            <div class="info-tip__options">
                <div class="info-tip__option">Количество занятий: ${selectedOffers.length}</div>
                <div class="info-tip__option">Стоимость: ${this.signupPrice} ₽</div>
            </div>
        `;
        this.modalFormSelectedOffers.value = JSON.stringify(offers);
        this.offersTotal.innerHTML = selectedOptionsHtml;
        this.modalFormSubmit.innerHTML = `<span>Оплатить <strong>${this.signupPrice} ₽</strong></span>`;
    }

    _clickSignup = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const selectedOffers = this.signupContainer.querySelectorAll('input[name="block-signup__checkbox"]:checked');
        
        if (selectedOffers.length == 0) {
            notice('Выберите предложение', 'warning');
            return;
        } else {
            this.openModal();
        }
    }

    openModal() {
        this.modalOpened = true;
        lockScroll();
        this.modalFormContainer.classList.add('modal--open');
    }

    closeModal() {
        unlockScroll();
        this.modalFormContainer.classList.remove('modal--open');
        this.modalOpened = false;
    }

}

export { Signup };